module.exports = __webpack_public_path__ + "img/NotOpen.77573f62.svg";